import React, { Component } from "react";
import ComingSoon from '../../assets/images/EventSoon.jfif';

export default class UpcomingSessionsPage extends Component {
    // constructor() {
    //     super();

    // }
    render() {
        return (
            <div className="upcoming-sessions-main">

                <div className="container-fluid">

                    <div className="row">
                        <div className="col-12">
                            <div className="coming-soon-img">
                            <img src={ComingSoon} alt="loading..."/>
                            <h4>Coming soon</h4>
                            <p>We will notify you when Event feature become available.</p>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
        )

    }
}

